import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";
import { parseISO } from "date-fns";

const WarningContainer = styled.div`
  background-color: ${(props) =>
    props.show ? "var(--pmbChestnut)" : "transparent"};
  opacity: ${(props) => (props.show ? 1 : 0)};
  color: white;
  width: 100%;
  font-weight: 700;
  line-height: 26px;
  text-align: center;
  transition: background-color 0.3s ease-in, opacity 0.4s ease-in,
    height 0.3s ease-in;
  height: ${(props) => (props.show ? "50px" : "0px")};
  position: relative;

  p {
    padding: 12px;
  }
`;

const WarningLink = styled(GatsbyLink)`
  color: var(--creamWhite);
`;

export const AccountSubscriptionWarning = ({ date, showWarning }) => {
  const [expireDate, setExpireDate] = useState("");

  useEffect(() => {
    setExpireDate(parseISO(date).toLocaleDateString());
  }, [setExpireDate, date]);

  return (
    <WarningContainer show={showWarning}>
      <p>
        En vänlig påminnelse: Ditt abonnemang löper ut {expireDate}. Läs mer och{" "}
        <WarningLink to="/extend-subscription">förläng här</WarningLink>.
      </p>
    </WarningContainer>
  );
};
